/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;



//////////////////
// WEBPACK FOOTER
// ./~/victory-box-plot/~/lodash/_freeGlobal.js
// module id = ./node_modules/victory-box-plot/node_modules/lodash/_freeGlobal.js
// module chunks = 1